import { Divider, Row, Typography } from "antd";
import Button from "../../Button";
import { Container } from "./styles";
import { formatCurrency } from "../../../utils";
import { UserPlan as IUserPlan } from "../../../constants/plans";
import { useAuth } from "../../../contexts/AuthContext";
interface PlanProps {
  plan: IUserPlan;
  planBuyed: string;
  handleSelect: React.MouseEventHandler;
}

export const UserPlan: React.FC<PlanProps> = ({
  plan,
  planBuyed,
  handleSelect,
}) => {
  const { user } = useAuth();
  const isActive = user?.user?.userPlanInfoVelotax?.active;


  return (
    <Container>
      <Typography.Title level={3}>{plan.title}</Typography.Title>
      <div className="price">
        <Typography.Title
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
          level={4}
        >
          {plan.free ? (
            <span> Gratuito</span>
          ) : (
            <div>
              {formatCurrency(plan.price)}{" "}
              <span className="per-month">/ mês</span>
              <br />
              <span className="per-month">
                {" "}
                plano {plan?.interval.toLocaleLowerCase()}
              </span>
            </div>
          )}
          <br />
          {!plan.free && plan.originalPrice !== plan.price && (
            <div className="original-price">
              <Typography.Text delete>
                {formatCurrency(plan.originalPrice)}{" "}
              </Typography.Text>
              <Typography.Text
                style={{ color: "var(--ant-error-color)" }}
                className="per-month"
              >{`${plan.percentDiscount}% de desconto ${plan.discountText ? plan.discountText : ""
                }`}</Typography.Text>
            </div>
          )}
        </Typography.Title>
      </div>
      <div
        style={{ marginTop: plan.free ? 55 : 0 }}
        className="included-features-user"
      >
        {plan.includedFeatures.map((feature: any) => (
          <div className="feature" key={feature.name}>
            <span>
              {feature.name}
              {feature?.secondaryIcon}
            </span>
            <span>{feature.icon}</span>
          </div>
        ))}
      </div>
      <Divider />
      <div className="other-features">
        {plan.descriptions.map((feature: any) => (
          <div className="feature" style={{ marginTop: 3 }} key={feature.label}>
            <span style={{ opacity: !feature.checked ? 0.5 : 1 }}>
              {feature.label}
              {feature.info}
            </span>
            <span>{feature.icon}</span>
          </div>
        ))}
      </div>
      <Row style={{ marginTop: plan.free ? 55 : 0 }} justify="end">
        <Button
          disabled={(planBuyed && isActive) || !!plan.free}
          type="primary"
          size="large"
          onClick={handleSelect}
        >
          {planBuyed && isActive && plan.type === user.user.userPlanInfoVelotax.type ? "Plano Selecionado!" : "Selecionar"}
        </Button>
      </Row>
    </Container>
  );
};
